import banner from './banner';
import bannerContainer from './bannerContainer';
import specialPromoGifts from './specialPromoGifts';
import promoCode from './promoCode';
import promoGifts from './promoGifts';

export default { banner, bannerContainer, specialPromoGifts, promoCode, promoGifts };
